var _style, _g, _g2, _g3, _g4, _rect, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorPortfolio02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C25443;}\n\t.st1{fill:#AE4B3C;}\n\t.st2{opacity:0.25;fill:#FFFFFF;}\n\t.st3{fill:none;}\n\t.st4{fill:#D0D2D3;}\n\t.st5{fill:#BBBDBD;}\n\t.st6{fill:#E6E7E8;}\n\t.st7{fill:#2D2D2E;}\n\t.st8{fill:#C3996B;}\n\t.st9{fill:#AF8960;}\n\t.st10{fill:#603813;}\n\t.st11{fill:#A87C4F;}\n\t.st12{fill:none;stroke:#8A5D3B;stroke-width:3;stroke-miterlimit:10;}\n\t.st13{opacity:0.2;fill:#231F20;}\n\t.st14{fill:#BBBDBF;}\n\t.st15{fill:#DDDEDF;}\n\t.st16{fill:#906548;}\n\t.st17{fill:#B58E64;}\n\t.st18{fill:#896642;}\n\t.st19{fill:#A87C4F;stroke:#6A4D32;stroke-width:3;stroke-miterlimit:10;}\n\t.st20{fill:#D0D2D3;stroke:#9FA1A3;stroke-width:3;stroke-miterlimit:10;}\n\t.st21{fill:#A5F1E9;}\n\t.st22{fill:#8CB347;}\n\t.st23{fill:#603E2A;}\n\t.st24{fill:none;stroke:#231F20;stroke-width:4;stroke-miterlimit:10;}\n\t.st25{fill:#231F20;}\n\t.st26{fill:#8A5D3B;}\n\t.st27{opacity:0.2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M382.64,849.57c-0.24-0.36-0.51-0.7-0.75-1.06c7.12-19.31,10.18-40.12,8.6-60.83 c-2.28-29.81-14.12-58.32-33.14-81.14c9.51-19.2,13.89-40.88,12.24-62.42c-2.37-30.89-17.04-60.12-40.28-80.57 c-8.57-5.76-17.15-11.51-25.72-17.27c-19.7-9.63-40.49-13.67-62.36-12.12c-10.1,2.13-20.21,4.25-30.32,6.38 c-19.65,7-36.4,18.3-50.26,33.9c-21.13,24-31.83,56.19-29.39,88.08c1.04,13.61,4.48,26.89,9.98,39.25c-0.66,0.72-1.35,1.39-2,2.12 c-25.41,28.87-38.28,67.57-35.34,105.92c1.02,13.29,3.96,26.32,8.57,38.71c-4.27,6.23-8.16,12.8-11.64,19.73 c-1.43,2.92-2.75,5.86-4,8.82c-11.32,23.44-17.52,58.02-14.69,82.83c2.32,28.45,11.42,54.54,27.3,78.25 c23.96,35.51,61.48,60.36,103.56,68.54c42.08,8.18,86.18-0.8,121.7-24.76c12.84-8.66,24.3-19.14,34.1-30.97 c0.07-0.06,0.14-0.13,0.2-0.19c18.9-18.38,33.77-53.47,38.58-78.65c0.85-14.58,1.71-29.17,2.56-43.75 C407.8,899.71,398.63,873.44,382.64,849.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M142.13,966.79c0-27.08,7.65-52.62,20.85-74.61c-7.77-17.86-12.11-37.44-12.11-57.9 c0-45.37,21.29-86.52,54.27-113.85c-7.66-17.73-11.93-37.15-11.93-57.43c0-54.1,30.36-102.15,74.69-127.88 c-8.7-1.28-17.59-1.62-26.67-0.98c-10.1,2.13-20.21,4.25-30.32,6.38c-19.65,7-36.4,18.3-50.26,33.9 c-21.13,24-31.83,56.19-29.39,88.08c1.04,13.61,4.48,26.89,9.98,39.25c-0.66,0.72-1.35,1.39-2,2.12 c-25.41,28.87-38.28,67.57-35.34,105.92c1.02,13.29,3.96,26.32,8.57,38.71c-4.27,6.23-8.16,12.8-11.64,19.73 c-1.43,2.92-2.75,5.86-4,8.82c-11.32,23.44-17.52,58.02-14.69,82.83c2.32,28.45,11.42,54.54,27.3,78.25 c23.96,35.51,61.48,60.36,103.56,68.54c13.4,2.61,27,3.45,40.47,2.65C190.1,1093.02,142.13,1034.67,142.13,966.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "296.6,937.41 293.25,934.07 259.03,957.49 251.54,882.58 240.19,882.58 227.44,1010.14  207.44,996.46 204.1,999.8 225.36,1030.88 211.84,1166.16 279.9,1166.16 262.07,987.87  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M354.44,1166.16h-91.51c0-25.27,20.49-45.76,45.76-45.76C333.95,1120.4,354.44,1140.89,354.44,1166.16z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1146.03,
    y: 938.66,
    className: "st16",
    width: 25.47,
    height: 227.51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1207.01,
    y: 938.66,
    className: "st16",
    width: 25.47,
    height: 227.51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1268,
    y: 938.66,
    className: "st16",
    width: 25.47,
    height: 227.51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1321.17,
    y: 938.66,
    className: "st16",
    width: 25.47,
    height: 227.51
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1106.37,
    y: 994.53,
    className: "st11",
    width: 279.93,
    height: 25.47
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1250.68,1166.16h-185.25c-0.31-0.73-0.59-1.49-0.86-2.24c-0.13-0.36-0.27-0.72-0.4-1.08 c-0.6-1.73-1.11-3.47-1.53-5.21c0-0.01-0.01-0.01,0-0.02c-0.41-1.76-0.73-3.51-0.97-5.28c-0.58-4.58-0.54-9.18,0.13-13.85 c0.06-0.42,0.13-0.84,0.19-1.27c0.06-0.42,0.15-0.84,0.23-1.27c1.81-9.14,5.77-17.2,11.89-24.21c2.04-2.3,4.24-4.37,6.58-6.23 c0.03-0.26,0.05-0.51,0.09-0.76c0.03-0.27,0.06-0.54,0.11-0.82s0.09-0.56,0.12-0.84c0.04-0.28,0.1-0.56,0.15-0.84 c1.26-6.37,4.03-12.02,8.3-16.91c4.18-4.69,9.23-8.11,15.15-10.22c4.17-1.44,8.39-2.1,12.67-2c0.67-0.92,1.38-1.81,2.13-2.67 c4.65-5.23,10.27-9.02,16.86-11.37c3.39-0.71,6.78-1.42,10.17-2.14c7.33-0.52,14.31,0.84,20.92,4.07l8.62,5.79 c0.67,0.59,1.31,1.22,1.94,1.84c1.08-0.89,2.2-1.74,3.36-2.52c9.1-6.14,20.39-8.44,31.17-6.35c10.78,2.1,20.39,8.46,26.53,17.56 c4.07,6.08,6.41,12.76,7,20.05c0.08,0.41,0.14,0.81,0.22,1.21c0.54,7.66-0.87,14.92-4.24,21.81c-0.83,1.64-1.73,3.21-2.73,4.69 c7.32,7.19,11.93,16.95,12.72,27.21C1252.28,1156.97,1251.85,1161.66,1250.68,1166.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1140.12,1058.3c-3.54,4.93-6.46,10.33-8.59,16.09c-7.21,3.28-13.86,7.84-19.53,13.51 c-3.49,4.52-6.98,9.03-10.46,13.56c-6.06,10.43-9.11,21.69-9.14,33.79c-0.03,0.48-0.04,0.98-0.06,1.46 c0.8,5.94,1.59,11.88,2.39,17.82c1.14,4.07,2.62,7.96,4.42,11.64h-33.73c-0.3-0.72-0.58-1.44-0.84-2.19 c-0.13-0.37-0.27-0.72-0.4-1.09c-0.6-1.74-1.12-3.5-1.53-5.25c0-0.01-0.01-0.01,0-0.02c-0.42-1.76-0.74-3.51-0.97-5.28 c-0.58-4.58-0.54-9.18,0.13-13.85c0.06-0.42,0.13-0.84,0.19-1.27c0.08-0.41,0.15-0.82,0.23-1.23c1.81-9.13,5.77-17.2,11.89-24.2 c2.04-2.3,4.24-4.37,6.58-6.24v-0.04c0.03-0.26,0.05-0.51,0.09-0.76c0.03-0.27,0.06-0.54,0.11-0.82s0.09-0.56,0.12-0.84 c0.05-0.27,0.1-0.53,0.15-0.79c1.26-6.38,4.03-12.02,8.3-16.91c4.18-4.7,9.23-8.11,15.15-10.23c4.17-1.44,8.39-2.09,12.67-1.99 c0.67-0.92,1.38-1.82,2.13-2.67c4.65-5.23,10.27-9.02,16.86-11.37C1137.56,1058.84,1138.84,1058.57,1140.12,1058.3z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 1166.28,
    className: "st25",
    width: 1407.5,
    height: 1.88
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 919.85,
    y1: 514.86,
    x2: 753.4,
    y2: 324.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1005.63,1166.15 494.37,1166.15 602.98,513.77 909.08,513.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "911.42,529.54 600.36,529.54 602.99,513.77 909.09,513.77  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 861.83,
    y: 829.43,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860.26,
    y: 827.68,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 895.7,
    y: 724.42,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 894.14,
    y: 722.67,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866.63,
    y: 742.54,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 865.06,
    y: 740.79,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 816.26,
    y: 649.61,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.99,
    y: 576.15,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.18,
    y: 561.62,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.24,
    y: 888.14,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.68,
    y: 886.39,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.82,
    y: 854.1,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.25,
    y: 852.35,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.21,
    y: 758.13,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.31,
    y: 703.11,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.33,
    y: 873.73,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 568.77,
    y: 871.98,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.71,
    y: 1025.37,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.14,
    y: 1023.62,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.04,
    y: 1076.84,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.47,
    y: 1075.08,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.94,
    y: 1042.52,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.37,
    y: 1040.77,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.28,
    y: 1134.44,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.71,
    y: 1132.69,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 861.72,
    y: 960.92,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860.15,
    y: 959.16,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 833.47,
    y: 1087.1,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 831.9,
    y: 1085.35,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 914.63,
    y: 1122.52,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 913.06,
    y: 1120.77,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.96,
    y: 977.42,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.4,
    y: 975.67,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.01,
    y: 994,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 872.44,
    y: 992.25,
    className: "st6",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 881.57,
    y: 881.08,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.68,
    y: 1010.59,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.72,
    y: 932.14,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.99,
    y: 1090.97,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.28,
    y: 777.73,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 663.03,
    y: 627.48,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 785.48,
    y: 569.97,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840.11,
    y: 765.37,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 925.92,
    y: 1034.66,
    className: "st5",
    width: 49.9,
    height: 12.36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M799.89,809.97h-86.06v-120c0-6.16,5-11.16,11.16-11.16h63.74c6.16,0,11.16,5,11.16,11.16V809.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 754.08,
    y: 678.81,
    className: "st3",
    width: 5.56,
    height: 125.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 754.08,
    y: 678.81,
    className: "st3",
    width: 5.56,
    height: 125.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 754.08,
    y: 677.37,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1477.2506 -36.4621)",
    className: "st8",
    width: 5.56,
    height: 86.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 755.97,
    y: 679.26,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1479.1415 -34.5712)",
    className: "st9",
    width: 1.78,
    height: 86.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 754.08,
    y: 719.79,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1519.6802 5.9674)",
    className: "st8",
    width: 5.56,
    height: 86.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 756.03,
    y: 721.74,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1521.6287 7.916)",
    className: "st9",
    width: 1.66,
    height: 86.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 754.08,
    y: 678.81,
    className: "st8",
    width: 5.56,
    height: 125.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 703.94,
    y: 798.52,
    className: "st5",
    width: 109.27,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 700.5,
    y: 795.9,
    className: "st6",
    width: 109.27,
    height: 18.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M819.55,1166.15H694.17v-192.4c0-6.16,5-11.16,11.16-11.16h103.06c6.16,0,11.16,5,11.16,11.16V1166.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M701.41,1166.15V979.64c0-5.42,4.39-9.81,9.81-9.81h91.27c5.42,0,9.81,4.39,9.81,9.81v186.51H701.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 756.15,
    y: 969.83,
    className: "st26",
    width: 1.41,
    height: 196.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 783.88,
    y: 969.83,
    className: "st26",
    width: 1.41,
    height: 196.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 797.74,
    y: 969.83,
    className: "st26",
    width: 1.41,
    height: 196.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 770.01,
    y: 969.83,
    className: "st26",
    width: 1.41,
    height: 196.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 742.29,
    y: 969.83,
    className: "st26",
    width: 1.41,
    height: 196.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 714.57,
    y: 969.83,
    className: "st26",
    width: 1.41,
    height: 196.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 728.43,
    y: 969.83,
    className: "st26",
    width: 1.41,
    height: 196.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 715.34,
    cy: 1066.63,
    r: 7.24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 714.7,
    cy: 1065.87,
    r: 6.73
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -541.7715 818.7582)",
    className: "st15",
    cx: 717.44,
    cy: 1063.36,
    rx: 2.21,
    ry: 3.18
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 701.41,
    y: 1019.67,
    className: "st25",
    width: 110.9,
    height: 16.74
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 701.41,
    y: 1016.07,
    className: "st8",
    width: 110.9,
    height: 16.74
  })), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 701.41,
    y: 1105.59,
    className: "st25",
    width: 110.9,
    height: 16.74
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 701.41,
    y: 1101.99,
    className: "st8",
    width: 110.9,
    height: 16.74
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M744.03,331.68L585.54,487.72c-10.1,9.94-3.06,27.13,11.11,27.13h316.98c14.17,0,21.21-17.19,11.11-27.13 L766.25,331.68C760.09,325.61,750.19,325.61,744.03,331.68z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorPortfolio02);
export default __webpack_public_path__ + "static/media/vector-portfolio-02.87427fff87881270a9d03f13de6ab8ed.svg";
export { ForwardRef as ReactComponent };